import {
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Stack,
} from '@mui/material';
import Button from '@mui/material/Button';

export type ModalProps = {
    open: boolean;
    tid?: string;
    title?: string;
    message?: React.ReactNode | JSX.Element[] | JSX.Element;
    setOpen?: (open: boolean) => void;
    loading?: boolean;
    cancel?: () => void;
    cancelText?: string;
    cancelDisabled?: boolean;
    confirm?: () => void;
    confirmText?: string;
    confirmDisabled?: boolean;
    close?: (event: object, reason: string) => void;
};

export default function Modal({
    tid,
    title,
    message,
    open,
    loading,
    cancel,
    close,
    cancelText,
    cancelDisabled,
    confirm,
    confirmText,
    confirmDisabled,
}: ModalProps): JSX.Element {
    return (
        <Dialog
            data-testid={tid ?? 'modal-dialog'}
            data-cy="modal-dialog"
            open={open}
            onClose={close ?? cancel}
            aria-labelledby="modal-title"
            aria-describedby="modal-content"
            disableEscapeKeyDown
            PaperProps={{
                sx: {
                    maxWidth: '600px',
                    width: '100%',
                    padding: '32px',
                    borderRadius: '10px',
                },
            }}
        >
            {title && (
                <DialogTitle
                    id="modal-title"
                    textAlign="left"
                    sx={{ padding: 0, paddingBottom: 2 }}
                >
                    {title}
                </DialogTitle>
            )}

            {message && (
                <DialogContent color="InfoText" sx={{ padding: 0, paddingBottom: 4 }}>
                    {message}
                </DialogContent>
            )}
            {(cancel || confirm) && (
                <DialogActions sx={{ padding: 0 }}>
                    <Grid container justifyContent="space-between" spacing={2}>
                        {cancel && (
                            <Grid item>
                                {cancel && (
                                    <Button
                                        disabled={loading || cancelDisabled}
                                        data-testid="btn-cancel"
                                        variant="outlined"
                                        onClick={cancel}
                                    >
                                        {cancelText ?? 'Cancel'}
                                    </Button>
                                )}
                            </Grid>
                        )}
                        {confirm && (
                            <Grid item>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    {loading && <CircularProgress size="1.5rem" />}
                                    <Button
                                        data-testid="btn-confirm"
                                        variant="contained"
                                        disabled={loading || confirmDisabled}
                                        onClick={confirm}
                                    >
                                        {confirmText ?? 'Confirm'}
                                    </Button>
                                </Stack>
                            </Grid>
                        )}
                    </Grid>
                </DialogActions>
            )}
        </Dialog>
    );
}
